import React from 'react';
import Form from "react-bootstrap/Form";

const AffiliationInfoForm = ({fields, handleFieldChange, emailMismatchMessage, messages, page, isEdit, mt}) => {
  return (
    <>
      <h3>所属先</h3>
      <dl>
        <dt>名称<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationName" className="inlineFormControl" size="lg">
            <Form.Control
              type="text"
              name="affiliationName"
              value={fields.affiliationName}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationNameMessage" className="errorMessages">{messages.affiliationName.n}</p>
        </dd>

        <dt>{ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? '学部・学科等' : '部署' }<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationDepertment" size="lg">
            <Form.Control
              type="text"
              name="affiliationDepertment"
              value={fields.affiliationDepertment}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationDepertmentMessage" className="errorMessages">{messages.affiliationDepertment.n}</p>
        </dd>

        <dt style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>職名</dt>
        <dd style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>
          <Form.Group controlId="affiliationPosition" size="lg">
            <Form.Control
              type="text"
              name="affiliationPosition"
              value={fields.affiliationPosition}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationPositionMessage" className="errorMessages">{messages.affiliationPosition.n}</p>
        </dd>

        <dt style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>職種<span className="red">*</span></dt>
        <dd style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>
          <Form.Group controlId="affiliationOccupation" size="lg">
            <Form.Control
              type="text"
              name="affiliationOccupation"
              value={fields.affiliationOccupation}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationOccupationMessage" className="errorMessages">{messages.affiliationOccupation.n}</p>
        </dd>

        <dt>郵便番号<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationPostalCode" size="lg">
            <Form.Control
              type="text"
              name="affiliationPostalCode"
              value={fields.affiliationPostalCode}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）例: 123-4567</p>
          <p id="affiliationPostalCodeMessage" className="errorMessages">{messages.affiliationPostalCode.n}</p>
        </dd>

        <dt>所在地<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationAddress" size="lg">
            <Form.Control
              type="text"
              name="affiliationAddress"
              value={fields.affiliationAddress ? fields.affiliationAddress.replace('#',' ') : ""}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationAddressMessage" className="errorMessages">{messages.affiliationAddress.n}</p>
        </dd>

        <dt>所在地（フリガナ）<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationAddressKana" size="lg">
            <Form.Control
              type="text"
              name="affiliationAddressKana"
              value={fields.affiliationAddressKana}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationAddressKanaMessage" className="errorMessages">{messages.affiliationAddressKana.n}</p>
        </dd>

        <dt>電話番号<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationTel" size="lg">
            <Form.Control
              type="text"
              name="affiliationTel"
              value={fields.affiliationTel}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）<br className="xs_block"/>例: 03-1234-5678</p>
          <p id="affiliationTelMessage" className="errorMessages">{messages.affiliationTel.n}</p>
        </dd>

        <dt>FAX</dt>
        <dd>
          <Form.Group controlId="affiliationFax" size="lg">
            <Form.Control
              type="text"
              name="affiliationFax"
              value={fields.affiliationFax}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>ハイフンで区切ってください（半角）<br className="xs_block"/>例: 03-1234-5678</p>
          <p id="affiliationFaxMessage" className="errorMessages">{messages.affiliationFax.n}</p>
        </dd>

        <dt>Email<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationEmail" size="lg">
            <Form.Control
              type="text"
              name="affiliationEmail"
              value={fields.affiliationEmail}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationEmailMessage" className="errorMessages">{messages.affiliationEmail.n}</p>
        </dd>

        <dt>Email（確認用）<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="affiliationEmailConfirmation" size="lg">
            <Form.Control
              type="text"
              name="affiliationEmailConfirmation"
              value={fields.affiliationEmailConfirmation}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="affiliationEmailConfirmationMessage" className="errorMessages">{messages.affiliationEmailConfirmation.n}</p>
          <p id="emailMismatchMessage" className="errorMessages">{ emailMismatchMessage }</p>
        </dd>

      </dl>
    </>
  );
}

export default AffiliationInfoForm;
